// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sign-in-email-confirm[data-v-4d3271a8]{min-height:100vh;display:flex;justify-content:center;align-items:center}@media(max-width:767px){.sign-in-email-confirm .nav-logo-mobile[data-v-4d3271a8]{left:50%;transform:translateX(-80px)}}.sign-in-email-confirm .confirm-button[data-v-4d3271a8]:hover{background:#ff883c!important}", ""]);
// Exports
module.exports = exports;
